import $ from 'jquery';
import _ from 'underscore';

import ScreenerSetItemCollection from 'screener/collections/screener_set_item';
import UserProgressCollection from 'screener/collections/user_progress';
import ScreenerPageView from 'screener/views/page';
import LoadingView from 'core/views/loading';


export default ScreenerPageView.extend({
  events: {
    'click .disabled': 'prevent_default',
    'click #strengths-list a': 'prevent_default'
  },

  initialize: function () {
    _.bindAll.apply(_, [this].concat(_.functions(this)));

    this.loadingView = new LoadingView({ el: $('body') });
    this.loadingView.show();

    // Saved elements
    this.survey_sections = $('.survey-section', this.el);
    this.your_plan = $('#your-plan', this.el);

    // Collections
    this.screener_set_item_collection = new ScreenerSetItemCollection();
    this.user_progress_collection = new UserProgressCollection();
  },

  render: function () {
    // Fetch data and render
    var options = { cache: true, expires: 86400, prefill: true };
    $.when(
      this.user_progress_collection.fetch(options),
      this.screener_set_item_collection.fetch(options)
    ).then(this.renderWithData);

    $(document).on('shown.bs.modal', '.tracking-modal', {}, function (ev) {
      $(ev.target).find('.modal-body').removeClass('show-borders');
      var carouselHeight = $(ev.target).find('.carousel').height();
      if ($(ev.target).find('.carousel-inner').height() > carouselHeight) {
        $(ev.target).find('.modal-body').addClass('show-borders');
      }
    });

    this.once('screeners-ready', this.open_screener);
  },

  open_screener: function () {
    // Check if we should open a screener, and if so, do it
    var screenerSection = this.survey_sections.filter('.open');
    if (screenerSection.length) {
      $('> a.take-screener-btn', screenerSection).click();
    }
  },

  renderWithData: function () {
    this.create_screener_views();

    this.render_plan();
    this.loadingView.hide();
  },

  render_plan: function () {
    // Render the plan section
    if (this.user_progress_collection.length === 0) {
      return;
    }
    var self = this;
    var gotPlans = [];
    this.your_plan.html('<ul id="mood-boosters" class="activity-list"></ul>');
    this.mood_boosters = $('#mood-boosters', this.your_plan);
    this.user_progress_collection.sort();
    var completed = this.user_progress_collection.filter(function (progress) {
      return progress.get('completed_at') !== null;
    });
    _.each(completed.reverse(), function (userProgress) {
      if (!_.contains(gotPlans, userProgress.get('screener_set_item'))) {
        gotPlans.push(userProgress.get('screener_set_item'));
        var screenerSetItem = self.screener_set_item_collection.findWhere({
          resource_uri: userProgress.get('screener_set_item')
        });
        var screenerName = '';
        if (screenerSetItem) {
          screenerName = `<b>${screenerSetItem.get('screener').name}:</b> `;
        }
        _.each(userProgress.get('feedbacks'), function (feedback) {
          if (feedback.plan_text) {
            self.mood_boosters.append(`
              <li>
                <span class="ss-icon ss-pushpin"></span>
                <div class="feedback-list-item">
                  ${screenerName}${feedback.plan_text}
                </div>
              </li>
            `);
          }
        });
      }
    });
  }
});



// WEBPACK FOOTER //
// ./static/js/views/your_plan.js